export enum LoadDisposition {
  loadIsSideBySide = 'loadIsSideBySide',
  loadIsEndToEnd = 'loadIsEndToEnd',
  loadIsStacked = 'loadIsStacked',
  loadIsNested = 'loadIsNested',
}

export const LoadDispositionValues = Object.values(LoadDisposition);
